"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _ExperimentDesignTablePropTypes = _interopRequireDefault(require("./ExperimentDesignTablePropTypes.js"));

var _ExperimentDesignTable = require("./ExperimentDesignTable.js");

var _urijs = _interopRequireDefault(require("urijs"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var ExperimentDesignTab = function ExperimentDesignTab(_ref) {
  var isDifferential = _ref.isDifferential,
      downloadUrl = _ref.downloadUrl,
      atlasUrl = _ref.atlasUrl,
      table = _ref.table;
  return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("div", {
    className: "row expanded column margin-top-large"
  }, /*#__PURE__*/_react["default"].createElement("a", {
    className: "button float-right margin-bottom-none",
    href: (0, _urijs["default"])(downloadUrl, atlasUrl).toString()
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "glyphicon glyphicon-download-alt margin-right-medium"
  }), "Download")), /*#__PURE__*/_react["default"].createElement("div", {
    className: "row expanded column margin-top-large"
  }, isDifferential ? (0, _ExperimentDesignTable.DifferentialExperimentDesign)(table) : (0, _ExperimentDesignTable.BaselineExperimentDesign)(table)));
};

ExperimentDesignTab.propTypes = {
  isDifferential: _propTypes["default"].bool.isRequired,
  downloadUrl: _propTypes["default"].string.isRequired,
  atlasUrl: _propTypes["default"].string.isRequired,
  table: _propTypes["default"].shape(_ExperimentDesignTablePropTypes["default"])
};
var _default = ExperimentDesignTab;
exports["default"] = _default;